import { ConfigContext } from '@/contextAPI/configContext';
import { selectAllDashboardData, selectCurrentCycle } from '@/redux/selectors/dashboardSelectors';
import { AnimationSpec } from 'chart.js';
import { useContext } from 'react';
import DashboardWidget, { WidgetData } from '../../DashboardWidget';
import { ColorMap } from '../../Reusable/chartConfig';
import AverageTimesWidget from './AverageTimesWidget';
import { useAppSelector } from '@/redux/hooks';

function isFutureDate(dateString: string | object) {
  if (typeof dateString === 'object') {
    return false;
  }

  const date = new Date(dateString);
  const now = new Date();
  return date.getTime() > now.getTime();
}

function getCurrentCycleData(monthlyAvgData: any, indexOfType: number, cycle: any) {
  let response = 0;
  let noDataFlag = false;

  if (monthlyAvgData && monthlyAvgData[indexOfType]) {
    const filtered = typeof cycle === 'object' ? monthlyAvgData[indexOfType].data : monthlyAvgData[indexOfType].data.filter((info: any) => info.date === cycle)[0];

    if (filtered?.average_length_in_minutes !== undefined) {
      response = filtered.average_length_in_minutes;
    } else {
      noDataFlag = true;
      response = 0;
    }
  }

  return { response, noDataFlag };
}

function calculateTimerTotal(min: number) {
  if (min < 15) return 15;
  if (min < 30) return 30;
  else return Math.ceil(min / 60) * 60;
}

const AverageTimes = ({ title, caption }: WidgetData) => {
  const { tasksProgressMonthlyAvg } = useAppSelector(selectAllDashboardData);
  const currentCycle = useAppSelector(selectCurrentCycle);
  const isFuture = isFutureDate(currentCycle);

  const labelsOnly = tasksProgressMonthlyAvg ? tasksProgressMonthlyAvg.map((item: any) => item.task_type_group) : [];
  const { response: editData, noDataFlag: noEditData } = getCurrentCycleData(
    tasksProgressMonthlyAvg,
    labelsOnly.indexOf('edit'),
    isFuture ? 'All' : currentCycle
  );
  const { response: reviewData, noDataFlag: noReviewData } = getCurrentCycleData(
    tasksProgressMonthlyAvg,
    labelsOnly.indexOf('review'),
    isFuture ? 'All' : currentCycle
  );

  const dashboardConfig = useContext(ConfigContext)?.dashboardConfig;
  const colorOverrides = dashboardConfig?.defaultGraphs && dashboardConfig.defaultGraphs['average-times'];

  const data = [
    {
      values: [editData, calculateTimerTotal(editData)],
      colors: colorOverrides ? [colorOverrides.colors[0]] : ['info'],
      title: 'edit'
    },
    {
      values: [reviewData, calculateTimerTotal(reviewData)],
      colors: colorOverrides ? [colorOverrides.colors[1]] : ['success'],
      title: 'review'
    }
  ];

  return (
    <DashboardWidget {...{ title }} {...{ caption }}>
      {(colorMap: ColorMap, loading: boolean, animation: AnimationSpec<any>) => (
        <AverageTimesWidget
          colors={colorMap}
          loading={loading}
          animation={animation}
          data={data}
          noData={{ review: noReviewData, edit: noEditData }}
        />
      )}
    </DashboardWidget>
  );
};

export default AverageTimes;
